import styled from 'styled-components';

export const Message = styled.small`
  color: ${props => props.theme.palette.text.light};
  font-size: ${props => props.theme.typography.sizes.caption};
  text-align: center;
`;
